var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Login',{attrs:{"googleText":"Sign up with Google","twitterText":"Sign up with Twitter","emailText":"Or Sign up with Email","title":"You’ve been invited to join RadiTube","btnText":"Sign Up"}})}
var staticRenderFns = []

export { render, staticRenderFns }